enum AppVersionPermission {
  Prem_App_Version_Publish = 'Prem_App_Version_Publish',
  Prem_App_Version_Views = 'Prem_App_Version_Views',
}

export default AppVersionPermission;
